import { EAsyncStatus } from '../../../common/types/asyncStatus';
import { IMapState } from '../../types';

export function selectVisibleItemsCount(state: IMapState): number | undefined {
  const { activeType, data } = state.map.infrastructure;
  if (!activeType) {
    return undefined;
  }

  if ([EAsyncStatus.Initial, EAsyncStatus.Loading].includes(data[activeType].featuresStatus)) {
    return undefined;
  }

  return data[activeType].visibleItemsCount;
}
